import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { optimizeImageUrlHeight } from "@faire/web--source/common/images/optimizeImages";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSignupModalOpenFdHomepageBottomCtaClick } from "@faire/web-api--source/events/signup/click/modalOpenFdHomepageBottomCta";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { SignUpButton } from "../components/SignUpButton";
var FooterSignUpBase = function(param) {
    var brand = param.brand, loginUrl = param.loginUrl;
    var isSSR = useIsSSR();
    var imageUrl = optimizeImageUrlHeight(IImage.build(brand.banner_image), isSSR, 440);
    if (!brand.name) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Wrapper, {
        $imageUrl: imageUrl,
        children: /*#__PURE__*/ _jsx(OpacityLayer, {
            children: /*#__PURE__*/ _jsxs(Column, {
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ _jsx(Header, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "Msjr8D",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Ready to start ordering "
                                },
                                {
                                    type: 1,
                                    value: "brandCompanyName"
                                },
                                {
                                    type: 0,
                                    value: " online?"
                                }
                            ],
                            values: {
                                brandCompanyName: brand.name
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(SignUpButton, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    }),
                    /*#__PURE__*/ _jsx(SignInLink, {
                        loginUrl: loginUrl
                    })
                ]
            })
        })
    });
};
export var FooterSignUp = observer(FooterSignUpBase);
var SignInLink = function(param) {
    var loginUrl = param.loginUrl;
    var isBrandPreview = useIsBrandPreview();
    if (isBrandPreview) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: loginUrl !== null && loginUrl !== void 0 ? loginUrl : faireBaseUrl(),
        onClick: trackSignupModalOpenFdHomepageBottomCtaClick,
        tertiaryColor: Core.text.inverse,
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "nPwqPZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sign into Faire Account"
                }
            ]
        })
    });
};
var Wrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-42e69e8f-0"
})([
    "width:100%;height:440px;background-size:cover;background-position:center;position:relative;background-image:",
    ";",
    "{height:383px;}"
], function(props) {
    return "url(".concat(props.$imageUrl, ")");
}, responsiveMediaQueries.mobile);
var OpacityLayer = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-42e69e8f-1"
})([
    "position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,0.5);"
]);
var Header = styled(Typography).attrs({
    variant: "displayLSerifRegular",
    align: "center",
    color: "white"
}).withConfig({
    componentId: "sc-42e69e8f-2"
})([
    '&&&{font-family:"Big Caslon",serif;max-width:591px;margin-bottom:32px;',
    "{max-width:279px;font-size:34px;line-height:40px;}}"
], responsiveMediaQueries.mobile);
